export const CMTS_ROLE_CODES = {
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  TENANT_ADMIN: "TENANT_ADMIN",
  MANAGEMENT: "MANAGEMENT",
  QUALITY_HEAD: "QUALITY_HEAD",
  QUALITY_MANAGER: "QUALITY_MANAGER",
  DEPARTMENT_MANAGER: "DEPARTMENT_MANAGER",
  COMPLAINT_CREATOR: "COMPLAINANT",
  INVESTIGATOR: "FUNCTIONAL_EXPERT",
  RCA_LEAD: "RCA_LEAD",
  CAPA_OWNER: "CAPA_OWNER",
  VERIFICATION_OWNER: "VERIFICATION_OWNER",
  CUSTOMER_USER: "CUSTOMER_USER",
  SUPPLIER_USER: "SUPPLIER_USER",
  AUDITOR: "AUDITOR",
  REPORT_MANAGER: "REPORT_MANAGER",
  EVIDENCE_ADMIN: "EVIDENCE_ADMIN",
  SECURITY_VIEWER: "SECURITY_VIEWER",
} as const;

export type CmtsRoleCode = typeof CMTS_ROLE_CODES[keyof typeof CMTS_ROLE_CODES];

